var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlinedCommunicationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "streamlined-communication-icon_svg__a",
    d: "M0 45h46.452V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.548 5.806H20.323a2.177 2.177 0 00-2.178 2.178V22.5c0 1.203.975 2.177 2.178 2.177h23.225a2.177 2.177 0 002.178-2.177V7.984a2.177 2.177 0 00-2.178-2.178",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.548 25.403H20.323a2.906 2.906 0 01-2.904-2.903v-6.532h1.452V22.5c0 .8.651 1.452 1.452 1.452h23.225c.8 0 1.452-.652 1.452-1.452V7.984c0-.8-.651-1.452-1.452-1.452H20.323c-.8 0-1.452.652-1.452 1.452v5.806h-1.452V7.984c0-1.6 1.302-2.903 2.904-2.903h23.225a2.906 2.906 0 012.904 2.903V22.5c0 1.6-1.302 2.903-2.904 2.903",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.935 17.42a4.653 4.653 0 01-3.026-1.12L19.85 8.535l.945-1.102 9.059 7.764c1.16.993 3.005.993 4.162 0l9.06-7.764.945 1.102-9.06 7.765a4.653 4.653 0 01-3.026 1.12",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    d: "M43.035 23.013l-7.984-7.984 1.027-1.026 7.984 7.983zM25.19 18.658l-1.026-1.026 3.629-3.63 1.027 1.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.129 20.323H2.903A2.177 2.177 0 00.726 22.5v14.516c0 1.203.974 2.178 2.177 2.178H26.13a2.177 2.177 0 002.177-2.178V22.5a2.177 2.177 0 00-2.177-2.177",
    fill: "#F4A27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.129 39.92H2.903A2.906 2.906 0 010 37.015V22.5c0-1.6 1.302-2.903 2.903-2.903H26.13a2.906 2.906 0 012.903 2.903v7.258h-1.451V22.5c0-.8-.652-1.452-1.452-1.452H2.903c-.8 0-1.451.652-1.451 1.452v14.516c0 .8.65 1.452 1.451 1.452H26.13c.8 0 1.452-.652 1.452-1.452v-4.355h1.451v4.355c0 1.6-1.301 2.903-2.903 2.903",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.516 31.935a4.653 4.653 0 01-3.026-1.12l-9.059-7.764.944-1.102 9.06 7.765c1.159.992 3.004.992 4.162 0l8.312-7.745.989 1.062-8.333 7.764a4.667 4.667 0 01-3.049 1.14",
    fill: "#EE4900"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    d: "M25.616 37.53l-7.984-7.985 1.027-1.026 7.984 7.984zM3.416 37.53L2.39 36.502l7.62-7.621 1.027 1.026z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "streamlined-communication-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#streamlined-communication-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#streamlined-communication-icon_svg__b)",
    d: "M12.339 14.516h8.71v-1.451h-8.71zM7.258 6.532h7.984V5.081H7.258zM25.403 31.21h8.71v-1.452h-8.71zM31.21 39.92h7.984v-1.452H31.21zM4.355 6.532h1.451V5.081H4.355zM1.452 6.532h1.451V5.081H1.452zM9.435 14.516h1.452v-1.451H9.435zM40.645 39.92h1.452v-1.452h-1.452zM43.548 39.92H45v-1.452h-1.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCC0C4",
    mask: "url(#streamlined-communication-icon_svg__b)",
    d: "M14.516 45H34.84v-1.452H14.516zM36.29 45h1.452v-1.452H36.29zM39.194 45h1.451v-1.452h-1.451zM13.79 1.452h20.323V0H13.79zM10.887 1.452h1.452V0h-1.452zM7.984 1.452h1.451V0H7.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#streamlined-communication-icon_svg__b)",
    d: "M34.839 31.21h1.451v-1.452H34.84z"
  }))));
}
export default SvgStreamlinedCommunicationIcon;